import { EYapePromotionSearchMethod } from 'core/model/enums/yape.enum';
import { IYapePromotionListParams, IYapeQrListParams } from 'core/model/interfaces/yape/yape.interface';
import type { TSliceReducer } from 'core/store';
import type { IYapeState } from './types';

const updateYapePromoPage: TSliceReducer<IYapeState, number | undefined> = (state, { payload }) => {
  state.promo.list.pagination.currentPage = payload ?? 1;
};

const updateYapeQrPage: TSliceReducer<IYapeState, number | undefined> = (state, { payload }) => {
  state.qr.list.pagination.currentPage = payload ?? 1;
};

const changeSearchMethod: TSliceReducer<IYapeState, EYapePromotionSearchMethod> = (state, { payload }) => {
  state.promo.searchMethod = payload;
};

const updateYapePromoFilters: TSliceReducer<IYapeState, IYapePromotionListParams> = (state, { payload }) => {
  state.promo.filters = { ...state.promo.filters, ...payload };
};

const updateYapeQrFilters: TSliceReducer<IYapeState, IYapeQrListParams> = (state, { payload }) => {
  state.qr.filters = { ...state.qr.filters, ...payload };
};

const clearYapePromoFilters: TSliceReducer<IYapeState> = state => {
  state.promo.filters = {};
};

const clearYapeQrFilters: TSliceReducer<IYapeState> = state => {
  state.qr.filters = {};
};

const clearYapeForm: TSliceReducer<IYapeState> = state => {
  state.promo.form.loading = false;
  state.promo.form.success = false;
};

export const reducers = {
  updateYapePromoPage,
  updateYapeQrPage,
  changeSearchMethod,
  updateYapePromoFilters,
  updateYapeQrFilters,
  clearYapePromoFilters,
  clearYapeQrFilters,
  clearYapeForm,
};
